export const GROUPS = `
  query groups(
    $tenant_id: Int!
    $skip: Int
    $take: Int
    $orderBy: GroupOrderInput
    $filter: GroupFilterInput
    $searchText: String
  ) {
    groups(
      tenant_id: $tenant_id
      skip: $skip
      take: $take
      orderBy: $orderBy
      filter: $filter
      searchText: $searchText
    ) {
      __typename

      ... on Group {
        id
        name
        program_id
        program {
          id
          name
        }
        program_variant_id
        program_variant {
          id
          name
          scope
        }
        monthly_date
        load_date
        active
        close_date
        include
        sponsored
        tier
        budget
        vistage20_id
        vcg_id
        member_count
        vcg { 
        id
        vcg
        }
        group_chair {
          id
          chair_id
          chair {
            id
            contact {
              id
              firstname
              lastname
            }
          }
          date_from
          date_to
        }
        its
        uts
        dts
      }

      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const GET_GROUP = `
  query getGroup($id: Int!, $tenant_id: Int!) {
    getGroup(id: $id, tenant_id: $tenant_id) {
      __typename

      ... on Group {
        id
        name
        program_id
        program {
          id
          name
        }
        program_variant_id
        program_variant {
          id
          name
          scope
        }
        monthly_date
        load_date
        active
        close_date
        include
        sponsored
        tier
        budget
        vistage20_id
        vcg_id
        member_count
        vcg {
        id
        vcg
        }
        group_chair {
          id
          chair_id
          chair {
            id
            contact {
              id
              firstname
              lastname
            }
          }
          date_from
          date_to
        }
        its
        uts
        dts
      }

      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const GROUPS_COUNT = `
  query groupsCount(
    $tenant_id: Int!
    $orderBy: GroupOrderInput
    $filter: GroupFilterInput
    $searchText: String
  ) {
    groupsCount(
      tenant_id: $tenant_id
      orderBy: $orderBy
      filter: $filter
      searchText: $searchText
    ) {
      __typename

      ... on Count {
        count
      }

      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
